import { Loader2 } from "lucide-react";
import { formatMXN } from "../../../lib/whatsapp";
import { trackWhatsAppClickConversion } from "../../../lib/gtag";
import { PACKAGE_CATEGORIES } from "./constants";

export const SummaryStep = ({ form, selectedPackages, submitting, result, total, extras, album }) => (
  <div className="space-y-6">
    <h3 className="font-serif-display text-2xl text-white mb-2">Resumen de tu cotización</h3>
    {submitting ? (
      <div className="flex items-center gap-3 text-white/60" data-testid="quote-loading">
        <Loader2 className="animate-spin" size={20} /> Calculando...
      </div>
    ) : (
      <div className="space-y-3 text-sm text-white/80" data-testid="quote-summary">
        <p><span className="text-white/40">Nombre:</span> {form.name}</p>
        <p><span className="text-white/40">Teléfono:</span> {form.phone}</p>
        <p><span className="text-white/40">Fecha:</span> {form.event_date}</p>
        <p><span className="text-white/40">Ciudad:</span> {form.city}</p>
        <div>
          <span className="text-white/40">Paquetes:</span>
          <ul className="mt-1 space-y-1">
            {selectedPackages.map((p) => (
              <li key={p.id}>
                - {p.name} ({PACKAGE_CATEGORIES.find((c) => c.key === p.category)?.label}{p.hours > 0 ? `, ${p.hours}h` : ""}{p.photos_count > 0 ? `, ${p.photos_count} fotos` : ""}{p.videos_count > 0 ? `, ${p.videos_count} videos` : ""}{p.clips_count > 0 ? `, ${p.clips_count} clips` : ""}{p.video_master_count > 0 ? `, ${p.video_master_count} Video Master` : ""}): {formatMXN(p.price)}
              </li>
            ))}
          </ul>
        </div>
        <p>
          <span className="text-white/40">Extras:</span>{" "}
          {form.extras.length ? form.extras.map((id) => extras.find((x) => x.id === id)?.label).filter(Boolean).join(", ") : "Ninguno"}
        </p>
        {album?.summary && (
          <div data-testid="quote-summary-album">
            <span className="text-white/40">Álbum impreso:</span>
            <ul className="mt-1 space-y-1">
              <li>- {album.summary.typeLabel}, {album.summary.sizeLabel}, {album.summary.pages} páginas, Portada {album.summary.coverLabel}
                {album.summary.colorLabel ? `, Color ${album.summary.colorLabel}` : ""}
                {album.summary.personalizationLabel ? `, ${album.summary.personalizationLabel}` : ""}: {formatMXN(album.summary.price)}
              </li>
            </ul>
          </div>
        )}
        {(result?.quote?.travel_cost || result?.quote?.travel_cost_pending) && (
          <p data-testid="quote-summary-travel-cost">
            <span className="text-white/40">Viáticos:</span>{" "}
            {result.quote.travel_cost
              ? `${result.quote.travel_cost.city} — ${formatMXN(result.quote.travel_cost.price)}`
              : "Se cotizarán por separado según tu ubicación"}
          </p>
        )}

        <div className="pt-4 border-t border-white/10">
          <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Precio estimado total</p>
          <p data-testid="quote-final-price" className="font-serif-display text-4xl text-twp-gold">
            {formatMXN(result?.quote?.estimated_price ?? total)}
          </p>
        </div>

        <p className="text-white/40 text-xs italic pt-2">
          Este precio es un estimado basado en las opciones seleccionadas. Para confirmar disponibilidad, detalles del evento y precio final, envíame tu cotización por WhatsApp.
        </p>

        {result?.whatsapp_link && (
          <a
            data-testid="quote-whatsapp-submit-button"
            href={result.whatsapp_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackWhatsAppClickConversion}
            className="mt-4 inline-block w-full text-center px-8 py-4 bg-twp-gold text-black text-xs uppercase tracking-[0.2em] font-semibold hover:bg-white transition-colors"
          >
            Enviar cotización por WhatsApp
          </a>
        )}
      </div>
    )}
  </div>
);
